import Vue from 'vue'
import VueRouter from 'vue-router'

/** webview */
import WebView from '../webview/WebView'
import ErrorPage from '../webview/ErrorPage'
import AwayPage from '../webview/AwayPage'
import SgTempLogin from '../webview/SgTempLogin'

import SgRegistration from '../webview/SgRegistration'
import SgWirePhone from '../webview/SgWirePhone'
import SgWireServices from '../webview/SgWireServices'

import SgSettingsEmail from '../webview/email/SgSettingsEmail'
import SgSettingsEmailEdit from '../webview/email/SgSettingsEmailEdit'
import SgEmailConfirmPage from '../webview/email/SgEmailConfirmPage'

import SgSettingsPhone from '../webview/phone/SgSettingsPhone'
import SgSettingsPhoneEdit from '../webview/phone/SgSettingsPhoneEdit'

import SgSettings from '../webview/settings/SgSettings'
import SgSettingsNotifications from '../webview/settings/SgSettingsNotifications'
import SgSettingsReceipt from '../webview/settings/SgSettingsReceipt'
import SgSettingsCheque from '../webview/settings/SgSettingsCheque'
import SgSettingsSecure from '../webview/settings/SgSettingsSecure'

/** regular */
import SgQuickPay from '../views/quick-pay/SgQuickPay'
import SgQuickPayStatus from '../views/quick-pay/SgQuickPayStatus'
import SgQuickPaySupport from '../views/quick-pay/SgQuickPaySupport'
import SgQuickPaySuccess from '../views/quick-pay/SgQuickPaySuccess'

/** test */
import SgQuickPayFirst from '../views/quick-pay/SgQuickPayFirst'
import SgQuickPaySecond from '../views/quick-pay/SgQuickPaySecond'


Vue.use(VueRouter)

/* webpackChunkName: "pass" */

const routes = [

  { path: '/pay', name: 'quick-pay', component: SgQuickPay, children: [
    { path: ':unp/status', name: 'quick-pay-status', component: SgQuickPayStatus },
    { path: 'support', name: 'quick-pay-support', component: SgQuickPaySupport },
    { path: 'downloads', name: 'quick-pay-downloads', component: SgQuickPaySuccess },
    { path: 'first', name: 'quick-pay-first', component: SgQuickPayFirst },
    { path: 'second', name: 'quick-pay-second', component: SgQuickPaySecond }
  ] },


  { path: '', redirect: { name: 'wv-registration'}},

  { path: '/wv', component: WebView, props: true, children: [

    { path: '', redirect: { name: 'wv-registration' }},


    { path: 'wv-auth', name: 'wv-auth', component: SgTempLogin, props: true},

    
    { path: 'registration', name: 'wv-registration', component: SgRegistration },
    { path: 'wirephone', name: 'wv-wirephone', component: SgWirePhone, props: true },
    { path: 'wireservices', name: 'wv-wireservices', component: SgWireServices, props: true },

    { path: 'error', name: 'wv-error', props: true, component: ErrorPage },
    { path: 'away', name: 'wv-away', props: true, component: AwayPage},


    { path: 'settings', name: 'wv-settings', props: true, component: SgSettings },
    
    { path: 'settings/email', name: 'wv-settings-email', props: true, component: SgSettingsEmail },
    { path: 'settings/email/edit', name: 'wv-settings-email-edit', props: true, component: SgSettingsEmailEdit },
    { path: 'settings/email/confirm', name: 'wv-settings-email-confirm', props: true, component: SgEmailConfirmPage },

    { path: 'settings/phone', name: 'wv-settings-phone', props: true, component: SgSettingsPhone },
    { path: 'settings/phone/edit', name: 'wv-settings-phone-edit', props: true, component: SgSettingsPhoneEdit },

    { path: 'settings/notifications', name: 'wv-settings-notifications', props: true, component: SgSettingsNotifications },
    { path: 'settings/receipt', name: 'wv-settings-receipt', props: true, component: SgSettingsReceipt },
    { path: 'settings/cheque', name: 'wv-settings-cheque', props: true, component: SgSettingsCheque},
    { path: 'settings/secure', name: 'wv-settings-secure', props: true, component: SgSettingsSecure },

  ]}
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
